import axios from 'axios'
import qs from 'qs'
import { clone, getDefaultStrDate } from '@/util/libUtil.js'


const state = {
	date: new Date().toISOString().substr(0, 7),
	isOpenFilterDialog: false,
	selectedTipoComercial: null,
	selectedStatusComercial: null,
	holidayEvents: [],
	estadisticaConsecucion: {
		consecucion: [],
		isLoading: false,
	},
	paths: {
		consecucionPath: '/api/atenciones/stats/consecucionCount/',
		holidayPath: 'https://clients6.google.com/calendar/v3/calendars/es.spain%23holiday@group.v.calendar.google.com/events'
	}
}

const mutations = {
	date: (state, val) => {
		state.date = val
	},
	estadisticaConsecucion: (state, val) => {
		state.estadisticaConsecucion = clone(val)
	},
	isLoadingestadisticaConsecucion: (state, val) => {
		state.estadisticaConsecucion.isLoading = val
	},
	isOpenFilterDialog: (state, val) => {
		state.isOpenFilterDialog = val
	},
	selectedTipoComercial: (state, val) => {
		state.selectedTipoComercial = val
	},
	selectedStatusComercial: (state, val) => {
		state.selectedStatusComercial = val
	},
	holidayEvents: (state, val) => {
		state.holidayEvents = val
	}
}

const actions = {
	async fetchConsecucion({ state, commit, getters }) {

		try {
			commit('estadisticaConsecucion', {
				consecucion: [],
				isLoading: true,
			})
			const res = await axios.get(getters.getEndpointFromPath(state.paths.consecucionPath), {
				params: {
					'updated_on[]': [
						`${state.date}-1`,
						`${state.date}-${new Date(new Date().getFullYear(), state.date.split("-")[1], 0).getDate()}`
					]
				}
			})

			commit('estadisticaConsecucion', {
				consecucion: res.data,
				isLoading: false,
			})
		} catch (error) {
			console.log(error)
		}
	},
	// async fetchHolidayEventsinMonth({ state, commit, getters }) {
	// 	let strFirst = `${state.date}`
	// 	let strLast = `${state.date}-${new Date(new Date().getFullYear(), state.date.split("-")[1], 0).getDate()}`


	// 	try {
	// 		const res = await axios.get(state.paths.holidayPath, {
	// 			params: {
	// 				calendarId: 'es.spain#holiday@group.v.calendar.google.com',
	// 				singleEvents: 'true',
	// 				timeZone: 'Europe/Madrid',
	// 				maxAttendees: '1',
	// 				maxResults: '250',
	// 				sanitizeHtml: 'true',
	// 				timeMin: new Date(strFirst),
	// 				timeMax: new Date(strLast),
	// 				key: 'AIzaSyBNlYH01_9Hc5S1J9vuFmu2nUqBZJNAXxs',
	// 			}
	// 		})
	// 		commit('holidayEvents', res.items)
	// 	} catch (error) {
	// 		console.log(error)
	// 	}
	// },
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	),
	currentNameMonthYear: (state) => {
		return `${state.date.toLocaleString('es', {
			month: 'long',
			year: 'numeric',
		})}`;
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}


